import type { PoseTrack } from '@/shared/lib/sticky-scroll';

/**
 * 교육 히어로 카드 4장의 스크롤 궤적 — 계산은 공용 엔진(shared/lib/sticky-scroll)이 한다.
 *
 * 시작할 때 카드는 화면 아래쪽에 부채꼴 더미로 겹쳐 있다. 스크롤하면 더미가 떠오르며
 * 네 장이 한 줄로 펼쳐지고, 다 펼친 뒤에는 기울기 없이 반듯하게 멈춘다(레퍼런스의 행).
 * 홈 히어로와 달리 떠오르기(drift) 단계를 쓰지 않는다 — 펼친 행 자체가 이 섹션의 결론이다.
 */

export type EduCardSlot = 'basics' | 'practice' | 'automate' | 'contact';

/** 펼치기에 진행도의 65% 를 쓴다 — 나머지는 펼친 행을 읽을 시간이다 */
export const EDU_SPREAD_END = 0.65;

/** 카드 폭 + 간격 8% — 네 장의 중심은 이 간격의 ±0.5, ±1.5 배에 선다 */
const PITCH = 108;

const settled = (column: number): PoseTrack['spread'] => ({
  x: PITCH * column,
  y: 0,
  rotate: 0,
  scale: 1,
});

/**
 * 모인 자세의 y 는 카드 높이의 55~70% 아래 — 첫 화면에서 더미의 윗부분이 보여야
 * 「아래에 무언가 있다」가 읽혀 스크롤을 부른다(1440×900 기준으로 확인).
 */
export const EDU_TRACKS: Readonly<Record<EduCardSlot, PoseTrack>> = {
  basics: {
    stacked: { x: -26, y: 70, rotate: -14, scale: 0.9 },
    spread: settled(-1.5),
    drift: settled(-1.5),
  },
  practice: {
    stacked: { x: -9, y: 60, rotate: -5, scale: 0.9 },
    spread: settled(-0.5),
    drift: settled(-0.5),
  },
  automate: {
    stacked: { x: 9, y: 64, rotate: 6, scale: 0.9 },
    spread: settled(0.5),
    drift: settled(0.5),
  },
  contact: {
    stacked: { x: 26, y: 55, rotate: 15, scale: 0.9 },
    spread: settled(1.5),
    drift: settled(1.5),
  },
};
